import { render, staticRenderFns } from "./FlussiListComponent.vue?vue&type=template&id=5579a8b2"
import script from "./FlussiListComponent.vue?vue&type=script&lang=js"
export * from "./FlussiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports